export enum WedoDS6WMaturity {
  Open = 'ds6w:status.task_open',
  InProgress = 'ds6w:status.task_inprogress',
  Done = 'ds6w:status.task_done',
}

export enum QuestionDS6WMaturity {
  NotValidated = 'ds6w:status.swym_answeredbutnotvalidated',
  Validated = 'ds6w:status.swym_validated',
  NotAnswered = 'ds6w:status.swym_notanswered',
}
